import React, {FunctionComponent, useCallback, useContext, useState} from 'react';
import {WisetackContext} from "../../context/WisetackContext";
import {Wisetack} from "../../models/wisetack.model";
import "./Wisetack.scss";
import {Button} from "../ui-components/Button/Button";
import {SectionPreloader} from "../SectionPreloader/SectionPreloader";
import {WisetackLearnMoreDialog} from "../WisetackLearnMore/WisetackLearnMoreDialog";
import {PreviewDataContext} from "../../context/PreviewContext";
import {ToastService} from "../../service/ToastService";


export const WisetackInvoice: FunctionComponent = (props) => {
    const wisetack: Wisetack | null = useContext(WisetackContext).wisetack;
    const isWisetackLoading = useContext(WisetackContext).isWisetackLoading;
    const isPreview = useContext(PreviewDataContext).isPreviewMode;
    const [isWisetackLearnMoreDialogVisible, setWisetackLearnMoreDialogVisible] = useState<boolean>(false);

    const showWisetackLearnMoreDialog = useCallback(() => {
        setWisetackLearnMoreDialogVisible(true);
    }, [setWisetackLearnMoreDialogVisible]);

    const onCloseWisetackLearnMoreDialog = useCallback(() => {
        setWisetackLearnMoreDialogVisible(false)
    }, [setWisetackLearnMoreDialogVisible]);

    const onClickPreviewWisetack = useCallback(() => {
        ToastService.middleScreenWarningToast('This action is not available in preview mode.');
    }, []);

    const getPreviewContent = useCallback(() => {
        return (
            <>
                {wisetack && wisetack.asLowAs ? <section className="wisetack-container wisetack-preview-container">
                    Pay as low as <span className="wisetack-price">${wisetack.asLowAs.monthlyPayment}*</span> per month
                    {<div className="wisetack-buttons">
                        <a onClick={onClickPreviewWisetack}><Button id="wisetack-payment-button"
                                                                    className="payment-button">See Loan
                            Options</Button></a>
                    </div>}
                    <p className="wisetack-preview-disclosure">
                        *All financing is subject to credit approval. Your terms may vary. Payment
                        options through Wisetack are provided by our lending partners. For example, a
                        $1,000 purchase could cost $45.18 a month for 24 months, based on a 7.9%
                        APR, or $333.33 a month for 3 months, based on a 0% APR. Offers range from
                        0-35.9% APR based on creditworthiness. No other financing charges or
                        participation fees. See additional terms at https://wisetack.com/faqs.
                    </p>
                </section> : null}
            </>
        )
    }, [wisetack, isWisetackLearnMoreDialogVisible, onCloseWisetackLearnMoreDialog]);

    const getContent = useCallback(() => {
        return (
            <>
                {wisetack && wisetack.asLowAs ? <section className="wisetack-container">
                    Pay as low as <span className="wisetack-price">${wisetack.asLowAs.monthlyPayment}*</span> per month
                    {wisetack.link ? <div className="wisetack-buttons">
                        {<Button className="wisetack-learn-more-button" onClick={showWisetackLearnMoreDialog}>Learn
                            More</Button>}
                        <a target="_blank" href={wisetack.link}><Button id="wisetack-payment-button"
                                                                        className="payment-button">See Loan
                            Options</Button></a>
                    </div> : <div>
                        <Button id="wisetack-payment-button" className="payment-button"><SectionPreloader
                            size="small"/></Button>
                    </div>}
                </section> : null}
                {isWisetackLearnMoreDialogVisible &&
                    <WisetackLearnMoreDialog onCloseDialog={onCloseWisetackLearnMoreDialog}/>}
            </>
        )
    }, [wisetack, isWisetackLearnMoreDialogVisible, onCloseWisetackLearnMoreDialog]);

    return (
        <>
            {isPreview ? getPreviewContent() : getContent()}
        </>
    );
};
